import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import {
  useChangeDriverPumpSalaryMutation,
  useLazyGetDriverPumpSalaryDetailQuery,
} from 'bus/driverPumpMixerSalary/driverPumpMixerSalary';
import { DriverPumpSalaryItemCreate } from 'bus/driverPumpMixerSalary/types';

import { PumpSalaryForm } from '../../components';

type Props = {
  onRefresh: () => void;
  id: number;
};

const PUMP_SALARY_CREATE: DriverPumpSalaryItemCreate = {
  id: null,
  dateBegin: '',
  price: 0,
  pumpLen: 0,
  pumpQuencher: 0,
  pumpMoving: 0,
  pumpPipes: 0,
  downtime: 0,
  comment: '',
  minimalPumpDriverPrice: null,
  minimalPumpQuantity: null,
  pumpDriverOverPrice: null,
};

export const EditPumpSalaryModal: FC<Props> = ({ onRefresh, id }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<DriverPumpSalaryItemCreate>(PUMP_SALARY_CREATE);

  const [getDriverPumpSalaryDetail] = useLazyGetDriverPumpSalaryDetailQuery();
  const [changeDriverPumpSalary] = useChangeDriverPumpSalaryMutation();

  const getDriverDetail = useCallback(async () => {
    getDriverPumpSalaryDetail({ id })
      .unwrap()
      .then((data) => {
        if (isSuccess(data)) {
          setForm(data);
        }
      });
  }, [getDriverPumpSalaryDetail, id]);

  useEffect(() => {
    getDriverDetail();
  }, [getDriverDetail]);

  const handleChange = (
    name: keyof DriverPumpSalaryItemCreate,
    value: DriverPumpSalaryItemCreate[keyof DriverPumpSalaryItemCreate],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    const updateData: DriverPumpSalaryItemCreate = {
      ...form,
      id,
    };

    changeDriverPumpSalary(updateData).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Настройка зарплаты насосника успешно изменена', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Редактирование настройки зарплаты насосника"
      visible
      isLoadingSubmit={false}
      width={800}
      height="auto"
      textConfirm="Сохранить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <PumpSalaryForm form={form} onChange={handleChange} />
    </ModalForm>
  );
};
